import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import axios from "axios";

export const whatGEO = () => {
  return (dispatch, getState, { getFirestore }) => {
    //alert(1);
    axios
      .get("https://us-central1-fittok-4619a.cloudfunctions.net/api/geo")
      .then(({ data }) => {
        if (data.status === "OK") {
          dispatch({ type: "GEO_REC", cc: data.cc });
        }
      })
      .catch((err) => {
        dispatch({ type: "GEO_REC_ERR" });
      });
  };
};

const loadStripe = (callback) => {
  const existingScript = document.getElementById("stripeScript");
  if (!existingScript) {
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/";
    script.id = "stripeScript";
    document.body.appendChild(script);
    script.onload = () => {
      if (callback) callback();
    };
  }
  if (existingScript && callback) callback();
};

export const setDirect = () => {
  return (dispatch, getState, { getFirestore }) => {
    dispatch({ type: "SET_DIRECT" });
  };
};
export const deleteStripe = (stuff) => {
  return (dispatch, getState, { getFirestore }) => {
    dispatch({ type: "BILLING_LOADING" });

    axios
      .post(
        "https://us-central1-fittok-4619a.cloudfunctions.net/api/cancelstripe",
        stuff
      )
      .then(({ data }) => {
        ReactGA.event({
          category: "User",
          action: "Cancelled",
        });

        dispatch({ type: "BILLING_CANCELLED_DONE" });
      })
      .catch((err) => {
        dispatch({ type: "BILLING_LOADING_DONE" });
      });
  };
};

export const createStripe = (stuff) => {
  return (dispatch, getState, { getFirestore }) => {
    //console.log(stuff);

    loadStripe(() => {
      const stripe = window.Stripe
        ? window.Stripe(
            "pk_live_51HkBGQLGH9KfrLpZdrImrf4cZzSI3CelUJ37EnFobHbcUj6ei19XCefSOkt7fkukBVsRDc4MXz42CV5manmbuA4k00npHCQA8M"
          )
        : null;
      dispatch({ type: "BILLING_LOADING" });

      axios
        .post(
          "https://us-central1-fittok-4619a.cloudfunctions.net/api/createstripe",
          stuff
        )
        .then(({ data }) => {
          console.log(data);

          stripe.redirectToCheckout({
            sessionId: data.session.id,
          });

          dispatch({ type: "BILLING_LOADING_DONE" });
        })
        .catch((err) => {
          dispatch({ type: "BILLING_LOADING_DONE" });
        });
    });
  };
};

export const sendMessage = (obj) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    firestore.collection("support-logs").add({
      user: obj.id,
      email: obj.email,
      message: obj.message,
      when: new Date(),
    });
  };
};

export const addHistory = (obj) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    firestore.collection("workout-logs").add({
      user: obj.id,
      calories: obj.calories,
      category: obj.category,
      when: new Date(),
    });
  };
};

export const addProgress = (obj) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    firestore.collection("weight-logs").add({
      user: obj.id,
      weight: obj.goal_weight,
      when: obj.goal_date,
      added: new Date(),
    });
  };
};

export const updateGoal = (obj) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    firestore.collection("users").doc(obj.id).update({
      weightGoal: obj.goal_weight,
      weightDate: obj.goal_date,
    });
  };
};

export const cancelSub = (obj) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    firestore.collection("users").doc(obj.id).update({
      cancelNow: true,
    });
  };
};

export const deleteProfile = (obj) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    firestore.collection("users").doc(obj.id).update({
      disabled: true,
    });
  };
};

export const updateProfile = (obj) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    firestore.collection("users").doc(obj.id).update({
      weight: obj.weight,
      height: obj.height,
      age: obj.age,
      gender: obj.gender,
    });
  };
};

export const forgotPwd = (obj) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    dispatch({ type: "RESET_LOADING" });

    firebase
      .auth()
      .sendPasswordResetEmail(obj.email)
      .then(() => {
        dispatch({ type: "RESET_EMAIL_SENT" });
        dispatch({ type: "RESET_LOADING_STOP" });
      })
      .catch(function (error) {
        dispatch({ type: "RESET_EMAIL_ERROR" });
        dispatch({ type: "RESET_LOADING_STOP" });
      });
  };
};

export const signIn = (credentials) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();

    dispatch({ type: "LOGIN_LOADING" });

    firebase
      .auth()
      .signInWithEmailAndPassword(credentials.email, credentials.password)
      .then((userstuff) => {
        let uid = userstuff.user.uid;
        let userRef = firestore.collection("users");

        userRef
          .doc(uid)
          .get()
          .then((userDbStuff) => {
            dispatch({ type: "LOGIN_LOADING_STOP" });
            //console.log(userDbStuff);
            userDbStuff = userDbStuff.data();

            (async () => {
              await ReactGA.event({
                category: "User",
                action: "Log In",
              });
            })();

            if (userDbStuff.disabled) {
              //alert(1);
              dispatch({ type: "LOGIN_DISABLED" });
            } else if (userDbStuff.banned === 1) {
              dispatch({ type: "LOGIN_BANNED" });
            } else {
              dispatch({ type: "LOGIN_SUCCESS" });
            }
          });
      })
      .catch((err) => {
        dispatch({ type: "LOGIN_ERROR", err });
        dispatch({ type: "LOGIN_LOADING_STOP" });
      });
  };
};

export const signOut = () => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    firebase
      .auth()
      .signOut()
      .then(() => {
        dispatch({ type: "SIGNOUT_SUCCESS" });
      });

    window.location.reload(false);
  };
};

export const signUp = (newUser) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();

    dispatch({ type: "SIGNUP_LOADING" });

    firebase
      .auth()
      .createUserWithEmailAndPassword(newUser.email, newUser.password)
      .then((resp) => {
        //    (async () => await ReactGA.set({ userId: resp.user.uid }))();
        //   (async () => await ReactGA.set({ dimension1: resp.user.uid }))();
        /*  (async () =>
              await ReactGA.event({
                category: "User",
                action: "Account Created",
              }))();

            (async () => await ReactPixel.track("Lead"))();

            */

        (async () => {
          await ReactGA.event({
            category: "User",
            action: "Account Created",
          });
          await ReactGA.set({ userId: resp.user.uid });
          await ReactPixel.track("Lead");
        })();

        return firestore.collection("users").doc(resp.user.uid).set({
          email: newUser.email,
          weight: newUser.weight,
          height: newUser.height,
          age: newUser.age,
          gender: newUser.gender,
          signedUp: new Date(),
        });
      })
      .then(() => {
        dispatch({ type: "SIGNUP_SUCCESS" });
        dispatch({ type: "SIGNUP_LOADING_STOP" });
      })
      .catch((err) => {
        dispatch({ type: "SIGNUP_ERROR", err });
        dispatch({ type: "SIGNUP_LOADING_STOP" });
      });
  };
};
